module.exports = __webpack_public_path__ + "img/trophy.570b47c.svg";